// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttons {
  background-color: var(--primary-color);
  font-size: 20px;
  padding: 0px 30px;
  height: 58px;
  width: auto;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  color: #fff;
  background-image: linear-gradient(
    to right,
    var(--secondary-color),
    var(--secondary-color)
  );
  background-repeat: no-repeat;
  background-size: 0% 100%;
  transition: background-size 1s ease;
}

.buttons:hover {
  background-size: 100% 100%;
}

/* .buttons .large {
  width: 100px;
  height: 58px;
  font-size: 18px;
}
.buttons .green {
  background-color: green;
}
.buttons .red {
  background-color: red;
} */

@keyframes hoverSpread {
  from {
    background-size: 0% 100%; /* Start with no green color */
  }
  to {
    background-size: 100% 100%; /* End with full green color */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/ReuseableComp/ButtonHoverStyle.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX;;;;GAIC;EACD,4BAA4B;EAC5B,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE;IACE,wBAAwB,EAAE,8BAA8B;EAC1D;EACA;IACE,0BAA0B,EAAE,8BAA8B;EAC5D;AACF","sourcesContent":[".buttons {\n  background-color: var(--primary-color);\n  font-size: 20px;\n  padding: 0px 30px;\n  height: 58px;\n  width: auto;\n  border: none;\n  border-radius: 30px;\n  cursor: pointer;\n  color: #fff;\n  background-image: linear-gradient(\n    to right,\n    var(--secondary-color),\n    var(--secondary-color)\n  );\n  background-repeat: no-repeat;\n  background-size: 0% 100%;\n  transition: background-size 1s ease;\n}\n\n.buttons:hover {\n  background-size: 100% 100%;\n}\n\n/* .buttons .large {\n  width: 100px;\n  height: 58px;\n  font-size: 18px;\n}\n.buttons .green {\n  background-color: green;\n}\n.buttons .red {\n  background-color: red;\n} */\n\n@keyframes hoverSpread {\n  from {\n    background-size: 0% 100%; /* Start with no green color */\n  }\n  to {\n    background-size: 100% 100%; /* End with full green color */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
